import React from 'react';
import Animated from 'react-native-reanimated';
import {useReducedMotion} from 'react-native-reanimated';

import {createPulseStyle} from '../animation/pulse';
import {getSkeletonColors} from '../constants';
import type {BoneProps} from '../types';

export const Bone: React.FC<BoneProps> = React.memo(
  ({width, height, borderRadius = 4, style, animationDelay = 0, testID}) => {
    const reducedMotion = useReducedMotion();
    const colors = getSkeletonColors();

    return (
      <Animated.View
        testID={testID}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
        style={[
          {
            width,
            height,
            borderRadius,
            backgroundColor: colors.bone,
          },
          reducedMotion ? {opacity: 0.6} : createPulseStyle(animationDelay),
          style,
        ]}
      />
    );
  },
);

Bone.displayName = 'Bone';
